/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="dts/payload.d.ts" />

export class Helper {
    /**
     *
     * @param {any} value
     * @param {any} length
     */
    public truncate(value: any, length: any) {
        let len = parseInt(length);
        if (value) {
            if (value.length > len) {
                return $.trim(value).substring(0, len).split(' ').slice(0, -1).join(' ') + '...';
            } else {
                return $.trim(value);
            }
        }
    }

    /**
     * Convert english number to persian digit from specific class name e.g.'number'
     * @param {any} target
     */
    public persianDigit(target?: any) {

        if (!payload.currentLocale.IsRightToLeft) {
            return
        }

        let classNameTarget,
            text: any,
            persianChar,
            persianNumber,
            splitCharacter,
            getCharacterLength;

        classNameTarget = target || $('.js_number');
        if (classNameTarget) {
            $(classNameTarget).each(function () {
                text = $(this).text();
                persianChar = function () {
                    persianNumber = {
                        0: '۰',
                        1: '۱',
                        2: '۲',
                        3: '۳',
                        4: '۴',
                        5: '۵',
                        6: '۶',
                        7: '۷',
                        8: '۸',
                        9: '۹'
                    };
                    splitCharacter = text.split('');
                    getCharacterLength = splitCharacter.length;

                    for (let i = 0; i < getCharacterLength; i++) {
                        if (persianNumber[splitCharacter[i]]) {
                            splitCharacter[i] = persianNumber[splitCharacter[i]];
                        }
                    }
                    return splitCharacter.join('');
                };

                $(this).html(persianChar);
            });
        }
    }

    /**
     * Get Param Value from Page URL or from `url` Argument.
     * @param {any} name
     * @param {any} url
     */
    public getURLParam(name: any, url: any) {
        let regex,
            results;

        if (!url) {
            url = window.location.href;
        }

        name = name.replace(/[\[\]]/g, '\\$&');
        regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
        results = regex.exec(url);

        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    /**
     * disable and enable buttons
     * @param {any} input
     * @param {any} scrollTop
     */
    public statefulButton(input: any, scrollTop: any) {
        let attr: any = $(input).attr('disabled');

        if (typeof attr !== typeof undefined && attr !== false) {
            $(input).removeAttr('disabled');
        } else {
            $(input).attr('disabled', 'disabled');
        }

        if (scrollTop) {
            $('html, body').animate({ scrollTop: 170 }, 600);
        }

        return false;
    };

    public enumBuilder(obj: Object) {
        let result = {};
        for (let item in obj) {
            result[result[item] = obj[item]] = item;
        }
        return result;
    };
}

export class Sidebar {
    /**
     * @param {any} slideToggle
     * @param {any} sidebarContainer
     */
    public open(slideToggle: any, sidebarContainer: any) {
        slideToggle.toggleClass('collapsed');
        sidebarContainer.toggleClass('side_open');
    }

    /**
     *
     * @param value
     */
    public removeScroller(value: any) {
        if (value.hasClass('js_sidebarOpen')) {
            value.removeClass('js_sidebarOpen')
        } else {
            value.addClass('js_sidebarOpen');
        }
    }
}

export class App {
    public loadMethods() {
        const helper = new Helper();
        const sidebar = new Sidebar();

        let $mainContainer = $('.main-container');
        let $sidebarContainer = $('.js_sidebar-container');
        let $sidebarToggleInSidebar = $('.js_sideToggle-sidebar');
        let $sidebarToggleInHeader = $('.js_sideToggle-header');
        let $scrollUpButton = $('.scroll-top');
        let $navBar = $('.js_navbar');

        // change numbers into persian digits
        helper.persianDigit();

        $(window).on('resize', () => {
            if (window.outerWidth > 768) {
                if ($('body').hasClass('js_sidebarOpen')) {
                    $('body').removeClass('js_sidebarOpen');
                    sidebar.open($sidebarToggleInHeader, $sidebarContainer);
                }
            }
        });

        // side bar arrow and toggle container
        $sidebarToggleInSidebar.on('click', () => { 

            $(this).toggleClass('navbar-fixed');
            $sidebarContainer.toggleClass('sidebar-container_fix');


            $(this).toggleClass('arrow-reverse');
            $('.js_personal-information').toggleClass('hide');
            $('.user-avatar').toggleClass('hide');
            $('.user-profile-container').toggleClass('hide');
            $sidebarContainer.toggleClass('side_close');
            $mainContainer.toggleClass('main-container_wide');
        });

        $sidebarToggleInHeader.on('click', () => {
            $('html, body').animate({ scrollTop: 0 }, 200);
            sidebar.open($sidebarToggleInHeader, $sidebarContainer);
            sidebar.removeScroller($('body'));
        });

        // add fixed class to navbar
        if (!payload.isPlugin)
            $(window).on('scroll', (event: any) => {
                event.stopPropagation();
                let scrollTop = $(window).scrollTop();
                let headerOffset = $('header').offset().top;

                if (headerOffset == 0) {
                    //$navBar.addClass('navbar-fixed');
                    //$sidebarContainer.addClass('sidebar-container_fix');
                    return
                }

                if (scrollTop > headerOffset) {
                    //$navBar.addClass('navbar-fixed');
                    //$sidebarContainer.addClass('sidebar-container_fix');
                    $scrollUpButton.addClass('scroll-top_show');

                } else {
                    //$navBar.removeClass('navbar-fixed');
                    //$sidebarContainer.removeClass('sidebar-container_fix');
                    $scrollUpButton.removeClass('scroll-top_show');
                }
            });

        // scroll up button
        $scrollUpButton.on('click', () => {
            $('html, body').animate({
                scrollTop: 0
            }, 300);
        });
    }
}
